export default __webpack_public_path__ + "static/media/Boye (1).55af05f1.jpg";